import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerApiService } from 'src/app/shared/services/server-api.service';

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  myScenarioApis: any
  constructor(private http: HttpClient, private apisService: ServerApiService) {
    this.myScenarioApis = this.apisService.getApi.chatbot;
  }

  duplicateScenarioById = (params): Observable<any> => this.http.post(this.myScenarioApis.duplicateScenarioById, params);
  checkProjectName = (params): Observable<any> => this.http.post(this.myScenarioApis.checkProjectName, params);
  checkScenarioName = (params): Observable<any> => this.http.post(this.myScenarioApis.checkScenarioName, params);
  exportScenarioById = (params): Observable<any> => this.http.post(this.myScenarioApis.exportScenarioById, params);
  refreshScenarioById = (params): Observable<any> => this.http.post(this.myScenarioApis.refreshScenarioById, params);
  getrefreshscenarios = (params): Observable<any> => this.http.post(this.myScenarioApis.getrefreshscenarios, params);
  deletesingletonscenario = (params): Observable<any> => this.http.post(this.myScenarioApis.deletesingletonscenario, params);
  masterScenarioDelete = (params): Observable<any> => this.http.post(this.myScenarioApis.masterScenarioDelete, params);
  getScenariosForProject = (params): Observable<any> => this.http.post(this.myScenarioApis.getScenariosForProject, params);
  exportMasterScenarioById = (params): Observable<any> => this.http.post(this.myScenarioApis.exportMasterScenarioById, params);
  getAllProjectNames(): Observable<any> {return this.http.get(this.myScenarioApis.getAllProjectNames);}
  runqueryforbot(params): Observable<any> {return this.http.post(this.myScenarioApis.runqueryforbot, params);}
  runUserQueryForbot(params) : Observable<any> {
    console.log("hhere in runUserQuery")
    return this.http.post(this.myScenarioApis.runUserQueryForbot, params);
  }
  runGenericSearch(params): Observable<any> {return this.http.post(this.myScenarioApis.runGenericSearch, params);}
}
